import React from 'react';
import {
    IonModal,
    IonContent, IonIcon, IonButton,
} from '@ionic/react';
import {calendarOutline, chevronBackOutline, downloadOutline} from "ionicons/icons";
// import moment from "moment-timezone";
import {FacebookLoader} from "./Loader/FacebookLoader";
import moment from "moment-timezone";
import {callFunctionToDownload} from "../lib/downloadHelper";

export default function NewsLetterDetailModal({ isOpen, onDidDismiss,newsLetterDetailData }) {



    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            {(newsLetterDetailData?.id) ?
                <>
                    <IonContent fullscreen className="news-detail-page">
                        {(newsLetterDetailData?.id) ?
                            <>
                                <div className="news-detail-image-wrapper">
                                    <img src={newsLetterDetailData.image_url} alt={newsLetterDetailData.title}/>
                                    <div className="news-detail-top-buttons">
                                        {(onDidDismiss) ?
                                            <button onClick={onDidDismiss} className="circle-btn">
                                                <IonIcon icon={chevronBackOutline}/>
                                            </button>:''
                                        }
                                    </div>

                                    {/*<div className="news-detail-overlay">*/}
                                    {/*    <h1 className="news-detail-title">{eventDetailData.title}</h1>*/}
                                    {/*</div>*/}
                                </div>
                                <div className="news-detail-content">
                                    {/*<div className="event-details">*/}
                                    <h2 className="event-title">{newsLetterDetailData.caption}</h2>
                                    <div className="event-date-time">
                                        <IonIcon icon={calendarOutline} />{" "}
                                        <div>
                                            {new Date(newsLetterDetailData.newsletter_date).toLocaleString(
                                                "en-IN",
                                                {
                                                    weekday: "short",
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                }
                                            )}
                                        </div>
                                    </div>
                                    <div className="feed-text">
                                        <div className="feed-text-1-div">
                                            <p className="feed-caption">{moment(newsLetterDetailData.created_at).format('MMMM YYYY')}</p>
                                        </div>
                                        <IonButton onClick={()=>callFunctionToDownload(newsLetterDetailData.pdf_url)} expand="block" className="download-button">
                                            <IonIcon icon={downloadOutline}/>
                                        </IonButton>
                                    </div>
                                    {/*</div>*/}
                                </div>
                            </>
                            :
                            <FacebookLoader type={"facebookStyle"} item={4}/>
                        }
                    </IonContent>
                </>:''
            }
        </IonModal>
    );
}
